import { createContext, useState } from "react";
import { useDispatch } from "react-redux";

import {
  getBackUpService,
  streamBackUpService,
  getBackUpsService,
} from "./../../../services/userServices";
import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "./../../../redux/actions/loadingActions/loadingActions";
import { toastErrorMessage } from "../../../utils/toastMessage/toastMessage";
import { downloadBlob, downloadErrorMessage } from "../../../utils/downloadFile";


export const backUpAdminContext = createContext({
  backUps: [],
  setBackUps: () => {},
  handleGetBackUps: () => {},
  handleGetBackUp: () => {},
});

const BackUpAdminContext = ({ children }) => {
  // Redux Dispatch
  const dispatch = useDispatch();

  const [backUps, setBackUps] = useState([]);

  // Handle Get Back Ups Method
  const handleGetBackUps = async (event) => {
    event?.preventDefault();

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getBackUpsService();
      if (status === 200) {
        setBackUps(data.files);
      }
    } catch ({ response }) {
      toastErrorMessage(response?.data?.detail || "دریافت فهرست فایل‌های پشتیبان ناموفق بود.");
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  const handleGetBackUp = async (name) => {
    try {
      // Supported browsers stream large backups directly to the selected file.
      const handle = window.showSaveFilePicker
        ? await window.showSaveFilePicker({ suggestedName: name }) : null;
      dispatch(setLoadingTrueAction());
      if (handle) {
        const response = await streamBackUpService(name);
        if (!response.ok) {
          const error = new Error("Backup download failed");
          error.response = { data: await response.json() };
          throw error;
        }
        const target = await handle.createWritable();
        await response.body.pipeTo(target);
      } else {
        const { data } = await getBackUpService(name);
        downloadBlob(data, name);
      }
    } catch (error) {
      if (error.name !== "AbortError") {
        toastErrorMessage(await downloadErrorMessage(error, "دانلود فایل پشتیبان ناموفق بود."));
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <backUpAdminContext.Provider
      value={{
        backUps,
        setBackUps,
        handleGetBackUps,
        handleGetBackUp,
      }}
    >
      {children}
    </backUpAdminContext.Provider>
  );
};

export default BackUpAdminContext;
